<template>
  <div style="font-size: 13px;line-height: 18px">
    <div style="text-align: right">
      <el-button size="small" type="primary" @click="generateAndDownloadPDFs()">{{ $t('mdfeTranslate.DownloadAllInvoiceInformation') }}</el-button>
    </div>
    <div
      ref="virtualContainer"
      class="virtual-scroll-container"
      @scroll="handleScroll"
    >
      <div class="virtual-scroll-placeholder" :style="{ height: totalHeight + 'px' }">
        <div
          class="virtual-scroll-content"
          :style="{ transform: `translateY(${offsetY}px)` }"
        >
          <div v-for="(item, index) in visibleItems" :key="index" style="color:#000;padding: 7px">
            <div :id="'pdfData' + index" style="padding: 7px">
              <div style="text-align: center;font-weight: bold;margin-bottom: 15px;">DECLARO QUE RECEBI OS VOLUMES DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE</div>
              <div style="display:flex;">
                <div style="width: 35%">
                  <div>NOME</div>
                  <div style="border-bottom: 1px solid black; width: 100%;margin-top: 15px;" />
                  <div>DOCUMENTO</div>
                  <div style="border-bottom: 1px solid black; width: 100%;margin-top: 15px;" />
                </div>
                <div style="width: 200px;padding: 0 10px">
                  <div style="width: 100%;height: 80px;border: 1px solid black;" />
                  <div style="text-align: center">ASSINATURA/CARIMBO</div>
                </div>
                <div style="flex: 1;display:flex;">
                  <div style="flex: 1">
                    <div>TÉRMINO DA PRESTAÇÃO - DATA/HORA</div>
                    <div style="display: flex;padding-right: 10px;">
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                      <div style="flex: 1;border-bottom: 1px solid black;" />:
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                    </div>
                    <div>INÍCIO DA PRESTAÇÃO - DATA/HORA</div>
                    <div style="display: flex;padding-right: 10px;">
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                      <div style="flex: 1;border-bottom: 1px solid black;" />:
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                    </div>
                  </div>
                  <div style="width: 200px;">
                    <div style="text-align: right;font-size: 22px">CT-E</div>
                    <div>Nº DOCUMENTO：{{ item.invoiceNumber }}</div>
                    <div>SÉRIE：{{ item.serie }}</div>
                  </div>
                </div>
              </div>
              <div style="padding: 7px 0;border-top: 2px dashed black" />
              <div style="display:flex;">
                <div style="width: 200px;display: flex;flex-direction: column; justify-content: end;">
                  <div style="font-weight: bold">TIPO DO CT-e</div>
                  <div>{{ documentType[item.tpCTe] }}</div>
                </div>
                <div style="width: 300px;">
                  <div style="font-weight: bold">{{ item.company.companyName }} {{ item.company.fantasyName }}</div>
                  <div>{{ item.company.address }}, {{ item.company.number }}</div>
                  <div>{{ item.company.neighborhood }}</div>
                  <div>Telefone: {{ item.company.telephone }}</div>
                  <div>{{ item.company.city }} - {{ item.company.state }} <span style="margin-left: 20px">CEP: {{ item.company.zipcode }}</span></div>
                  <div><span style="font-weight: bold">CNPJ:</span> {{ item.company.companyCnpj }}</div>
                  <div><span style="font-weight: bold">IE:</span> {{ item.company.ie }}</div>
                  <div>
                    <div style="font-weight: bold">TIPO DO SERVIÇO</div>
                    <div>{{ serviceType[item.tpServ] }}</div>
                  </div>
                </div>
                <div style="flex: 1;">
                  <div style="display:flex;">
                    <div style="flex: 1;text-align: center;font-weight: bold">
                      <div>DACTE</div>
                      <div>Documento Auxiliar do</div>
                      <div>Conhecimento de Transporte</div>
                      <div>Eletrônico</div>
                    </div>
                    <div style="flex: 1;display: flex;">
                      <div style="flex: 1">
                        <div style="font-weight: bold">MODAL</div>
                        <div>{{ transportMode[item.modal] }}</div>
                      </div>
                      <div style="flex: 1;text-align: right;padding-right: 10px">
                        <div>FL</div>
                        <div>1/1</div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex">
                    <div style="width: 80px;">
                      <div style="font-weight: bold;text-align: right">MODEL</div>
                      <div style="text-align: right">{{ item.modelo }}</div>
                    </div>
                    <div style="width: 80px;">
                      <div style="font-weight: bold;text-align: right">SÉRIE</div>
                      <div style="text-align: right">{{ item.serie }}</div>
                    </div>
                    <div style="width: 120px;">
                      <div style="font-weight: bold;text-align: right">NÚMERO</div>
                      <div style="text-align: right">{{ item.invoiceNumber }}</div>
                    </div>
                    <div style="flex: 1;">
                      <div style="font-weight: bold;text-align: center">DATA E HORA DE EMISSÃO</div>
                      <div style="text-align: center">{{ item.cteCreateDate }}</div>
                    </div>
                  </div>
                  <img :id="'barcodeCon' + index">
                  <div>
                    <div>Chave de Acesso</div>
                    <div>
                      {{ item.invoiceKey }}
                    </div>
                  </div>
                </div>
                <div style="width: 200px;">
                  <div :id="'qrcode' + index" style="margin-top: 15px;" />
                </div>
              </div>
              <div style="display: flex;color:#000;margin: 10px 0;">
                <div style="width: 200px;">
                  <div style="font-weight: bold">INDICADOR DO CT-E</div>
                  <div style="display:flex;">
                    <div style="flex: 1">
                      <span style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;">X</span>SIM
                    </div>
                    <div style="flex: 1">
                      <div style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />NÃO
                    </div>
                  </div>
                </div>
                <div style="width: 260px;">
                  <div style="font-weight: bold">INF. DO CT-E GLOBALIZADO</div>
                  <div style="display:flex;">
                    <div style="flex: 1">
                      <span style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />SIM
                    </div>
                    <div style="flex: 1">
                      <div style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;">X</div>NÃO
                    </div>
                  </div>
                </div>
                <div style="flex: 1">
                  Consulta  <span style="font-weight: bold">http://www.cte.fazenda.gov.br</span>
                </div>
                <div style="flex: 1">
                  <div>TIPO DE CONTRATAÇÃO</div>
                  <div style="display:flex;">
                    <div style="flex: 1">
                      <span style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />REDESPACHO
                    </div>
                    <div style="flex: 1">
                      <div style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />SUBCONTRATAÇÃO
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex;color:#000;margin-bottom: 5px;">
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    CÓDIGO FISCAL DE OPERAÇÕES E PRESTAÇÕES - NATUREZA DA OPERAÇÃO
                  </div>
                  <div>
                    {{ item.cfop }}
                  </div>
                </div>
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    Protocolo de Autorização de Uso
                  </div>
                  <div>
                    {{ item.protocolo }} - {{ item.cteCreateDate }}
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-bottom: 5px;">
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    INÍCIO DA PRESTAÇÃO
                  </div>
                  <div>
                    {{ item.startCity }} - {{ item.startUf }}
                  </div>
                </div>
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    TÉRMINO DA PRESTAÇÃO
                  </div>
                  <div>
                    {{ item.endCity }} - {{ item.endUf }}
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-bottom: 10px;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-right: 5px;">
                  <div>REMETENTE <span style="margin-left: 15px">{{ item.remetente.name }}</span></div>
                  <div>ENDEREÇO <span style="margin-left: 15px">{{ item.remetente.address }}{{ item.remetente.city ? ', ' + item.remetente.city : '' }} {{ item.remetente.number }} {{ item.remetente.neighborhood }}</span></div>
                  <div style="display: flex">
                    <div style="flex: 1">
                      <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.remetente.city }}{{ item.remetente.state ? ' - ' + item.remetente.state : '' }}</span></div>
                      <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.remetente.cnpj }}</span></div>
                      <div>PAÍS <span style="margin-left: 15px">{{ item.remetente.country || '' }}</span></div>
                    </div>
                    <div style="flex: 1">
                      <div>CEP <span style="margin-left: 15px">{{ item.remetente.zipcode }}</span></div>
                      <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.remetente.ie }}</span></div>
                      <div>FONE <span style="margin-left: 15px">{{ item.remetente.telephone }}</span></div>
                    </div>
                  </div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-left: 5px">
                  <div>DESTINATÁRIO <span style="margin-left: 15px">{{ item.destinatario.name }}</span></div>
                  <div>ENDEREÇO <span style="margin-left: 15px">{{ item.destinatario.address }}{{ item.destinatario.city ? ', ' + item.remetente.city : '' }} {{ item.destinatario.number }} {{ item.destinatario.neighborhood }}</span></div>
                  <div style="display: flex">
                    <div style="flex: 1">
                      <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.destinatario.city }}{{ item.destinatario.state ? ' - ' + item.destinatario.state : '' }}</span></div>
                      <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.destinatario.cnpj }}</span></div>
                      <div>PAÍS <span style="margin-left: 15px">{{ item.destinatario.country || '' }}</span></div>
                    </div>
                    <div style="flex: 1">
                      <div>CEP <span style="margin-left: 15px">{{ item.destinatario.zipcode }}</span></div>
                      <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.destinatario.ie }}</span></div>
                      <div>FONE <span style="margin-left: 15px">{{ item.destinatario.telephone }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-bottom: 10px;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-right: 5px;">
                  <div>EXPEDIDOR <span style="margin-left: 15px">{{ item.expedidor.name }}</span></div>
                  <div>ENDEREÇO <span style="margin-left: 15px">{{ item.expedidor.address }}{{ item.expedidor.city ? ', ' + item.expedidor.city : '' }} {{ item.expedidor.number }} {{ item.expedidor.neighborhood }}</span></div>
                  <div style="display: flex">
                    <div style="flex: 1">
                      <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.expedidor.city }}{{ item.expedidor.state ? ' - ' + item.expedidor.state : '' }}</span></div>
                      <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.expedidor.cnpj }}</span></div>
                      <div>PAÍS <span style="margin-left: 15px">{{ item.expedidor.country || '' }}</span></div>
                    </div>
                    <div style="flex: 1">
                      <div>CEP <span style="margin-left: 15px">{{ item.expedidor.zipcode }}</span></div>
                      <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.expedidor.ie }}</span></div>
                      <div>FONE <span style="margin-left: 15px">{{ item.expedidor.telephone }}</span></div>
                    </div>
                  </div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-left: 5px">
                  <div v-if="item.customerId === 24005 || item.customerId === 24147">
                    <div>RECEBEDOR <span style="margin-left: 15px">{{ item.toma.name }}</span></div>
                    <div>ENDEREÇO <span style="margin-left: 15px">{{ item.toma.address }}{{ item.toma.city ? ', ' + item.toma.city : '' }} {{ item.toma.number }} {{ item.toma.neighborhood }}</span></div>
                    <div style="display: flex">
                      <div style="flex: 1">
                        <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.toma.city }}{{ item.toma.state ? ' - ' + item.toma.state : '' }}</span></div>
                        <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.toma.cnpj }}</span></div>
                        <div>PAÍS <span style="margin-left: 15px">{{ item.toma.country }}</span></div>
                      </div>
                      <div style="flex: 1">
                        <div>CEP <span style="margin-left: 15px">{{ item.toma.zipcode }}</span></div>
                        <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.toma.ie }}</span></div>
                        <div>FONE <span style="margin-left: 15px">{{ item.toma.telephone }}</span></div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div>RECEBEDOR <span style="margin-left: 15px">{{ item.recebedor.name }}</span></div>
                    <div>ENDEREÇO <span style="margin-left: 15px">{{ item.recebedor.address }}{{ item.recebedor.city ? ', ' + item.recebedor.city : '' }} {{ item.recebedor.number }} {{ item.recebedor.neighborhood }}</span></div>
                    <div style="display: flex">
                      <div style="flex: 1">
                        <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.recebedor.city }}{{ item.recebedor.state ? ' - ' + item.recebedor.state : '' }}</span></div>
                        <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.recebedor.cnpj }}</span></div>
                        <div>PAÍS <span style="margin-left: 15px">{{ item.recebedor.country }}</span></div>
                      </div>
                      <div style="flex: 1">
                        <div>CEP <span style="margin-left: 15px">{{ item.recebedor.zipcode }}</span></div>
                        <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.recebedor.ie }}</span></div>
                        <div>FONE <span style="margin-left: 15px">{{ item.recebedor.telephone }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px;margin-bottom: 10px;">
                <div style="display: flex;">
                  <div style="flex: 1">
                    TOMADOR DO SERVIÇO {{ item.toma.name }}
                  </div>
                  <div style="flex: 1;padding-left: 10px;">
                    MUNICÍPIO {{ item.toma.city }}{{ item.toma.state ? ' - ' + item.toma.state : '' }}
                  </div>
                  <div style="flex: 1">
                    CEP <span style="margin-left: 15px">{{ item.toma.zipcode }}</span>
                  </div>
                </div>
                <div>
                  ENDEREÇO <span style="margin-left: 10px;margin-right: 20px;">{{ item.toma.address }}{{ item.toma.city ? ', ' + item.toma.city : '' }} {{ item.toma.number }} {{ item.toma.neighborhood }}</span>
                  PAÍS<span style="padding-left: 10px">{{ item.toma.country || '' }}</span>
                </div>
                <div style="display: flex;">
                  <div style="flex: 1">
                    CNPJ / CPF <span style="margin-left: 15px">{{ item.toma.cnpj }}</span>
                  </div>
                  <div style="flex: 1">
                    INSCRIÇÃO <span style="margin-left: 15px">{{ item.toma.ie }}</span>
                  </div>
                  <div style="flex: 1">
                    FONE <span style="margin-left: 15px">{{ item.toma.telephone }}</span>
                  </div>
                </div>
              </div>
              <div style="display: flex;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div>PRODUTO PREDOMINANTE</div>
                  <div>{{ item.product || null }}</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div>OUTRAS CARACTERÍSTICAS DA CARGA</div>
                  <div>null</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div style="text-align: right">VALOR TOTAL DA CARGA</div>
                  <div style="text-align: right">R$ {{ formatNumber(item.productAmount) }}</div>
                </div>
              </div>
              <div style="display: flex;border: 1px solid #000;padding: 7px;">
                <div style="flex: 1;">QUANTIDADE：1</div>
                <div style="flex: 1;">PESO BRUTO (KG)：{{ item.peso }}</div>
                <div style="flex: 1;">QUANTIDADE DE PACOTES：01</div>
                <div style="flex: 1;">PESO AFERIDO (KG)：{{ item.pesoAferido }}</div>
                <div style="flex: 1;">CUBAGEM(M3)：{{ item.volumes }}</div>
              </div>
              <div style="border: 1px solid #000;padding: 7px 7px 0 7px;">
                <div style="padding: 7px;text-align: center;border: 1px solid #000;">COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO</div>
                <div style="display: flex;">
                  <div
                    v-for="(list, ind) in item.prest.freteDetail"
                    :key="ind"
                    style="flex: 1;border-right: 1px solid #000;padding-right: 10px"
                  >
                    <div style="display: flex;">
                      <div style="flex: 1">NOME</div>
                      <div style="flex: 1;text-align: right">VALOR</div>
                    </div>
                    <div style="display: flex;">
                      <div style="flex: 1">{{ list.name }}</div>
                      <div style="flex: 1;text-align: right">{{ formatNumber(list.value) }}</div>
                    </div>
                  </div>
                  <div style="flex: 1;text-align: right;">
                    <div>VALOR TOTAL DO SERVIÇO</div>
                    <div>R$ {{ formatNumber(item.prest.frete) }}</div>
                    <div>VALOR TOTAL A RECEBER</div>
                    <div>R$ {{ formatNumber(item.prest.receivablesFee) }}</div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px 7px 0 7px;">
                <div style="padding: 7px;text-align: center;border: 1px solid #000;">INFORMAÇÕES RELATIVAS A IMPOSTO</div>
                <div style="display: flex;">
                  <div style="width: 400px;border-right: 1px solid #000;padding-right: 10px">
                    <div>CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO</div>
                    <div>{{ item.icms.cst }}</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>BASE DE CÁLCULO</div>
                    <div style="text-align: right">R$ {{ formatNumber(item.icms.vbc) }}</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>ALÍQUOTA DO ICMS</div>
                    <div style="text-align: right">{{ item.icms.picms }} %</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>VALOR DO ICMS</div>
                    <div style="text-align: right">R$ {{ formatNumber(item.icms.vicms) }}</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>% RED BC.</div>
                    <div style="text-align: right">% {{ item.icms.predbc }}</div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px 7px 0 7px;">
                <div style="padding: 7px;text-align: center;border: 1px solid #000;">DOCUMENTOS ORIGINÁRIOS(NOTA FISCAL ELETRÔNICA)</div>
                <div style="display: flex;">
                  <div style="flex: 1;display: flex;border-right: 1px solid #000;">
                    <div style="width: 100px;">
                      <div style="text-align: left">MODELO</div>
                      <div style="text-align: left">{{ item.associationCte.modelo }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">SERIE</div>
                      <div style="text-align: left">{{ item.associationCte.serie }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">NÚMERO</div>
                      <div style="text-align: left">{{ item.associationCte.number }}</div>
                    </div>
                    <div style="flex: 1">
                      <div style="text-align: left">CHAVE DE ACESSO</div>
                      <div style="text-align: left">{{ item.associationCte.key }}</div>
                    </div>
                  </div>
                  <div style="flex: 1;display: flex;border-right: 1px solid #000;">
                    <div style="width: 100px;padding-left: 10px">
                      <div style="text-align: left">MODELO</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.modelo }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">SERIE</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.serie }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">NÚMERO</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.number }}</div>
                    </div>
                    <div style="flex: 1">
                      <div style="text-align: left">CHAVE DE ACESSO</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.key }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display:flex;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div>INFORMAÇÕES ADICIONAIS</div>
                  <div>
                    <div v-for="(list, ind) in item.additionalInfo" :key="ind">{{ list }}</div>
                  </div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px 7px 0 7px;">
                  <div>
                    <div style="border: 1px solid #000;padding: 7px;">INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO</div>
                    <div style="display: flex">
                      <div style="flex: 1;border-right: 1px solid #000;">
                        <div>RNTRC DA EMPRESA</div>
                        <div>{{ item.company.rntrc }}</div>
                      </div>
                      <div style="flex: 2;padding-left: 10px">
                        ESTE CONHECIMENTO DE TRANSPORTE ATENDE À LEGISLAÇÃO DE TRANSPORTE RODOVIÁRIO EM VIGOR
                      </div>
                    </div>
                  </div>

                  <div style="display: flex;margin-bottom: 10px;">
                    <div style="flex: 1;border: 1px solid #000;padding: 7px">
                      <div style="border: 1px solid #000;padding: 7px;margin-bottom: 100px">
                        USO EXCLUSIVO DO EMISSOR DO CT - E
                      </div>
                    </div>
                    <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                      <div style="border: 1px solid #000;padding: 7px">RESERVADO AO FISCO</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JsBarcode from 'jsbarcode';
import qrcode from 'qrcode-generator';
import JsPDF from 'jspdf';
import dayjs from 'dayjs';
import { icmsTaxType, transportMode, documentType, serviceType, mdfecfop } from '../../mdfe/enumeration';
import { Loading } from 'element-ui';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { formatNumber } from '@/utils/tools';
export default {
  props: {
    cteData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    createPdfType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      icmsTaxType,
      transportMode,
      documentType,
      serviceType,
      mdfecfop,
      options: {
        lock: true,
        // '生成图片中，等待下载'
        text: this.$t('organizationManage.GenerateImageWaitDownload'), // 加载动画的文字
        spinner: 'el-icon-loading', // 加载动画的图标
        background: 'rgba(255,255,255,0.8)', // 加载动画的背景
        customClass: 'custom-loading-zIndex'
      },
      itemHeight: 1800, // 每个item的预估高度
      containerHeight: 600, // 容器高度
      visibleItemCount: 10, // 可见的item数量
      visibleStartIndex: 0, // 可见区域的起始索引
      offsetY: 0, // 偏移量
      formatNumber
    };
  },
  computed: {
    // 计算总高度
    totalHeight() {
      return this.cteData.length * this.itemHeight;
    },

    // 计算可见的items
    visibleItems() {
      const start = this.visibleStartIndex;
      const end = Math.min(start + this.visibleItemCount, this.cteData.length);
      return this.cteData.slice(start, end);
    }
  },
  mounted() {
    // Loading.service(this.options);
    // 初始化容器高度
    this.updateContainerHeight();
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.cteData.map((item, index) => {
            // 生成条形码
            const element = document.getElementById('barcodeCon' + index);
            if (element && item.invoiceKey) {
              JsBarcode(element, item.invoiceKey, {
                height: 50,
                displayValue: false
              });
            }
            // 生成二维码
            const qr = qrcode(0, 'M');
            qr.addData(item.qrCodePath);
            qr.make();
            const canvas = document.createElement('canvas');
            const size = 120;
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');
            const cellSize = size / qr.getModuleCount();
            for (let row = 0; row < qr.getModuleCount(); row++) {
              for (let col = 0; col < qr.getModuleCount(); col++) {
                ctx.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
                ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
              }
            }
            document.getElementById('qrcode' + index).appendChild(canvas);
          });
          // setTimeout(() => {
          //   this.generateAndDownloadPDFs();
          // }, 500);
        }, 1000);
      });
    },
    async generateAndDownloadPDFs() {
      const loadingInstance = Loading.service(this.options);
      await new Promise(resolve => setTimeout(resolve, 100));
      const zip = new JSZip();
      const pdfFolder = zip.folder('pdfs');
      for (let i = 0; i < this.cteData.length; i++) {
        const pdfBlob = await this.generateSinglePDF(this.cteData[i]);
        pdfFolder.file(`${this.cteData[i].invoiceKey}.pdf`, pdfBlob);
      }
      // 生成 ZIP 并触发下载
      const dateTime = dayjs().format('YYYYMMDDHHmmss');
      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, 'cte_' + dateTime + '.zip');
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      });
    },
    async generateSinglePDF(item) {
      return new Promise((resolve) => {
        try {
          const doc = new JsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
          });
          // 页高
          const pageHeight = doc.internal.pageSize.height;
          // 页宽
          const pageWidth = doc.internal.pageSize.width;
          const xPosition = 5;
          let yPosition = 3;
          // 外围边框
          doc.rect(xPosition, yPosition, pageWidth - 10, pageHeight - 6);
          yPosition += 4;
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          // 标题
          const title1 = 'DECLARO QUE RECEBI OS VOLUMES DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR';
          const title2 = 'CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE';
          const title1Width = doc.getTextWidth(title1);
          const title2Width = doc.getTextWidth(title2);
          doc.text(title1, (pageWidth - title1Width) / 2, yPosition);
          yPosition += 4;
          doc.text(title2, (pageWidth - title2Width) / 2, yPosition);
          doc.setFont('helvetica', 'normal');
          yPosition += 5;
          // 姓名
          doc.text('NOME', xPosition + 5, yPosition);
          // 姓名下方横线
          doc.rect(xPosition + 5, yPosition + 8, 80, 0);
          // 文档
          doc.text('DOCUMENTO', xPosition + 5, yPosition + 12);
          // 文档下方横线
          doc.rect(xPosition + 5, yPosition + 20, 80, 0);
          // 中间方框
          doc.rect(91, yPosition, 60, 21);

          doc.text('TÉRMINO DA PRESTAÇÃO - DATA/HORA', 152, yPosition);
          // 姓名下方横线
          doc.rect(152, yPosition + 8, 17, 0);
          doc.text('/', 169, yPosition + 8);
          doc.rect(169, yPosition + 8, 17, 0);
          doc.text('/', 186, yPosition + 8);
          doc.rect(186, yPosition + 8, 17, 0);
          doc.text(':', 203, yPosition + 8);
          doc.rect(203, yPosition + 8, 17, 0);

          doc.text('INÍCIO DA PRESTAÇÃO - DATA/HORA', 152, yPosition + 12);
          doc.rect(152, yPosition + 20, 17, 0);
          doc.text('/', 169, yPosition + 20);
          doc.rect(169, yPosition + 20, 17, 0);
          doc.text('/', 186, yPosition + 20);
          doc.rect(186, yPosition + 20, 17, 0);
          doc.text(':', 203, yPosition + 20);
          doc.rect(203, yPosition + 20, 17, 0);

          doc.setFontSize(16);
          doc.setFont('helvetica', 'bold');
          doc.text('CT-E', 275, yPosition);
          doc.setFontSize(10);
          doc.setFont('helvetica', 'normal');
          doc.text('Nº DOCUMENTO', 230, yPosition + 12);
          doc.text((item.invoiceNumber || ''), 262, yPosition + 12);
          doc.text('SÉRIE', 230, yPosition + 16);
          doc.text((item.serie || ''), 245, yPosition + 16);
          yPosition += 25;
          const ASSINATURA = 'ASSINATURA/CARIMBO';
          const ASSINATURAWidth = doc.getTextWidth(ASSINATURA);
          doc.text(ASSINATURA, ((60 - ASSINATURAWidth) / 2) + 91, yPosition);
          // yPosition += 5;
          doc.setLineDash([2, 1]); // [线段长度, 间隔长度]
          doc.line(xPosition + 5, yPosition + 2, pageWidth - 10, yPosition); // 从左到右绘制横线
          doc.setLineDash([]);
          yPosition += 6;
          doc.setFont('helvetica', 'bold');
          doc.text(doc.splitTextToSize((item.company.companyName || '') + (item.company.fantasyName ? ' ' + item.company.fantasyName : ''), 80), xPosition + 30, yPosition);
          // doc.text((item.company.fantasyName || ''), xPosition + 30, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.address || '') + (item.company.number ? ' ' + item.company.number : ''), xPosition + 30, yPosition + 15);
          doc.text((item.company.neighborhood || ''), xPosition + 30, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('Telefone: ', xPosition + 30, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.telephone || ''), xPosition + 48, yPosition + 25);
          doc.text((item.company.city || '') + (item.company.state ? ' ' + item.company.state : ''), xPosition + 30, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP: ', xPosition + 30, yPosition + 35);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.zipcode || ''), xPosition + 40, yPosition + 35);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ: ', xPosition + 30, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.companyCnpj || ''), xPosition + 41, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('IE: ', xPosition + 30, yPosition + 45);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.ie || ''), xPosition + 36, yPosition + 45);
          doc.setFont('helvetica', 'bold');
          doc.text('TIPO DO SERVIÇO', xPosition + 30, yPosition + 50);
          doc.setFont('helvetica', 'normal');
          doc.text((item.tpServ ? this.serviceType[item.tpServ] : ''), xPosition + 30, yPosition + 55);

          doc.setFont('helvetica', 'bold');
          doc.text('DACTE', xPosition + 130, yPosition);
          doc.text('Documento Auxiliar do', xPosition + 130, yPosition + 5);
          doc.text('Conhecimento de Transporte', xPosition + 130, yPosition + 10);
          doc.text('Eletrônico', xPosition + 130, yPosition + 15);
          doc.text('MODAL', xPosition + 190, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text((item.modal ? this.transportMode[item.modal] : ''), xPosition + 190, yPosition + 5);

          doc.setFont('helvetica', 'bold');
          doc.text('MODEL', xPosition + 130, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.modelo || ''), xPosition + 130, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('SÉRIE', xPosition + 150, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.serie || ''), xPosition + 150, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('NÚMERO', xPosition + 165, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.invoiceNumber || ''), xPosition + 165, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('DATA E HORA DE EMISSÃO', xPosition + 190, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.cteCreateDate || ''), xPosition + 190, yPosition + 25);

          doc.text('FL', xPosition + 249, yPosition);
          doc.text('1/1', xPosition + 249, yPosition + 5);
          // 创建条形码canvas
          const barcodeCanvas = document.createElement('canvas');
          JsBarcode(barcodeCanvas, item.invoiceKey, {
            height: 40,
            displayValue: false
          });

          // 添加条形码到PDF
          const barcodeData = barcodeCanvas.toDataURL('image/png');
          const barcodeWidth = 100;
          const barcodeHeight = 20;
          doc.addImage(barcodeData, 'PNG', xPosition + 130, yPosition + 27, barcodeWidth, barcodeHeight);

          // 创建二维码canvas
          const qr = qrcode(0, 'M');
          qr.addData(item.qrCodePath);
          qr.make();

          const qrCanvas = document.createElement('canvas');
          const qrSize = 100;
          qrCanvas.width = qrSize;
          qrCanvas.height = qrSize;
          const ctx = qrCanvas.getContext('2d');

          // 绘制二维码
          for (let row = 0; row < qr.getModuleCount(); row++) {
            for (let col = 0; col < qr.getModuleCount(); col++) {
              ctx.fillStyle = qr.isDark(row, col) ? '#000000' : '#ffffff';
              ctx.fillRect(col * (qrSize / qr.getModuleCount()), row * (qrSize / qr.getModuleCount()),
                qrSize / qr.getModuleCount(), qrSize / qr.getModuleCount());
            }
          }

          // 添加二维码到PDF
          const qrData = qrCanvas.toDataURL('image/png');
          const qrWidth = 30;
          const qrHeight = 30;
          doc.addImage(qrData, 'PNG', xPosition + 255, yPosition, qrWidth, qrHeight);

          doc.setFont('helvetica', 'bold');
          doc.text('TIPO DO CT-e', xPosition + 5, yPosition + 60);
          doc.setFont('helvetica', 'normal');
          doc.text((item.tpCTe ? documentType[item.tpCTe] : ''), xPosition + 5, yPosition + 65);
          doc.text('Chave de Acesso', xPosition + 130, yPosition + 50);
          doc.text(item.invoiceKey, xPosition + 130, yPosition + 55);
          doc.text('Consulta', xPosition + 130, yPosition + 60);
          doc.text('http://www.cte.fazenda.gov.br', xPosition + 150, yPosition + 60);

          doc.setFont('helvetica', 'bold');
          yPosition += 70;
          doc.text('INDICADOR DO CT-E', xPosition + 5, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.rect(xPosition + 5, yPosition + 2, 6, 6);
          doc.text('X', xPosition + 6, yPosition + 6);
          doc.text('SIM', xPosition + 13, yPosition + 6);
          doc.rect(xPosition + 25, yPosition + 2, 6, 6);
          doc.text('NÃO', xPosition + 32, yPosition + 6);

          doc.setFont('helvetica', 'bold');
          doc.text('INF. DO CT-E GLOBALIZADO', xPosition + 60, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.rect(xPosition + 60, yPosition + 2, 6, 6);
          doc.text('SIM', xPosition + 68, yPosition + 6);
          doc.rect(xPosition + 80, yPosition + 2, 6, 6);
          doc.text('NÃO', xPosition + 88, yPosition + 6);
          doc.text('X', xPosition + 82, yPosition + 6);

          doc.setFont('helvetica', 'bold');
          doc.text('TIPO DE CONTRATAÇÃO', xPosition + 180, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.rect(xPosition + 180, yPosition + 2, 6, 6);
          doc.text('REDESPACHO', xPosition + 188, yPosition + 6);
          doc.rect(xPosition + 220, yPosition + 2, 6, 6);
          doc.text('SUBCONTRATAÇÃO', xPosition + 228, yPosition + 6);

          yPosition += 15;
          const halfWidth = pageWidth / 2;
          doc.setFont('helvetica', 'bold');
          doc.text('CÓDIGO FISCAL DE OPERAÇÕES E PRESTAÇÕES - NATUREZA DA OPERAÇÃO', xPosition + 5, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text((item.cfop || ''), xPosition + 5, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('INÍCIO DA PRESTAÇÃO', xPosition + 5, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          doc.text((item.startCity || '') + (item.startUf ? ' - ' + item.startUf : ''), xPosition + 5, yPosition + 15);

          doc.setFont('helvetica', 'bold');
          doc.text('Protocolo de Autorização de Uso', halfWidth + 5, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text((item.protocolo || '') + (item.cteCreateDate ? ' - ' + item.cteCreateDate : ''), halfWidth + 5, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('TÉRMINO DA PRESTAÇÃO', halfWidth + 5, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          doc.text((item.endCity || '') + (item.endUf ? ' - ' + item.endUf : ''), halfWidth + 5, yPosition + 15);
          yPosition += 20;
          doc.rect(xPosition + 5, yPosition, halfWidth - 10, 50);
          doc.rect(halfWidth + 5, yPosition, halfWidth - 15, 50);
          yPosition += 6;
          doc.setFont('helvetica', 'bold');
          doc.text('REMETENTE', xPosition + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.remetente.name || ''), 100), xPosition + 30, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', xPosition + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const remetenteAddress = (item.remetente.address || '') + (item.remetente.city ? ', ' + item.remetente.city : '') + (item.remetente.number ? ' ' + item.remetente.number : '') + (item.remetente.neighborhood ? ' ' + item.remetente.neighborhood : '');
          doc.text(doc.splitTextToSize(remetenteAddress, 110), xPosition + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', xPosition + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.remetente.city || '') + (item.remetente.state ? ' - ' + item.remetente.state : ''), 60), xPosition + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', xPosition + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.zipcode || ''), xPosition + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', xPosition + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.cnpj || ''), xPosition + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', xPosition + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.ie || ''), xPosition + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', xPosition + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.country || ''), xPosition + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', xPosition + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.telephone || ''), xPosition + 95, yPosition + 40);

          doc.setFont('helvetica', 'bold');
          doc.text('DESTINATÁRIO', halfWidth + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.destinatario.name || ''), 100), halfWidth + 34, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', halfWidth + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const destinatarioAddress = (item.destinatario.address || '') + (item.destinatario.city ? ', ' + item.destinatario.city : '') + (item.destinatario.number ? ' ' + item.destinatario.number : '') + (item.destinatario.neighborhood ? ' ' + item.destinatario.neighborhood : '');
          doc.text(doc.splitTextToSize(destinatarioAddress, 110), halfWidth + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', halfWidth + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.destinatario.city || '') + (item.destinatario.state ? ' - ' + item.destinatario.state : ''), 60), halfWidth + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', halfWidth + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.zipcode || ''), halfWidth + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', halfWidth + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.cnpj || ''), halfWidth + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', halfWidth + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.ie || ''), halfWidth + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', halfWidth + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.country || ''), halfWidth + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', halfWidth + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.telephone || ''), halfWidth + 95, yPosition + 40);

          // 添加新页面用于表格数据
          doc.addPage();
          yPosition = 3;
          // 外围边框
          doc.rect(xPosition, yPosition, pageWidth - 10, pageHeight - 6);
          yPosition += 3;
          doc.rect(xPosition + 5, yPosition, halfWidth - 10, 50);
          doc.rect(halfWidth + 5, yPosition, halfWidth - 15, 50);
          yPosition += 6;
          doc.setFont('helvetica', 'bold');
          doc.text('EXPEDIDOR', xPosition + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.expedidor.name || ''), 100), xPosition + 30, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', xPosition + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const expedidorAddress = (item.expedidor.address || '') + (item.expedidor.city ? ', ' + item.expedidor.city : '') + (item.expedidor.number ? ' ' + item.expedidor.number : '') + (item.expedidor.neighborhood ? ' ' + item.expedidor.neighborhood : '');
          doc.text(doc.splitTextToSize(expedidorAddress, 110), xPosition + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', xPosition + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.expedidor.city || '') + (item.expedidor.state ? ' - ' + item.expedidor.state : ''), 60), xPosition + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', xPosition + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.zipcode || ''), xPosition + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', xPosition + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.cnpj || ''), xPosition + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', xPosition + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.ie || ''), xPosition + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', xPosition + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.country || ''), xPosition + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', xPosition + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.telephone || ''), xPosition + 95, yPosition + 40);

          const toma = item.customerId === 24005 || item.customerId === 24147 ? item.toma : item.recebedor;
          doc.setFont('helvetica', 'bold');
          doc.text('RECEBEDOR', halfWidth + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((toma.name || ''), 100), halfWidth + 30, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', halfWidth + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const tomaAddress = (toma.address || '') + (toma.city ? ', ' + toma.city : '') + (toma.number ? ' ' + toma.number : '') + (toma.neighborhood ? ' ' + toma.neighborhood : '');
          doc.text(doc.splitTextToSize(tomaAddress, 110), halfWidth + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', halfWidth + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((toma.city || '') + (toma.state ? ' - ' + toma.state : ''), 60), halfWidth + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', halfWidth + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.zipcode || ''), halfWidth + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', halfWidth + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.cnpj || ''), halfWidth + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', halfWidth + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.ie || ''), halfWidth + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', halfWidth + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.country || ''), halfWidth + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', halfWidth + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.telephone || ''), halfWidth + 95, yPosition + 40);

          yPosition += 45;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 20);
          doc.setFont('helvetica', 'bold');
          doc.text('TOMADOR DO SERVIÇO', xPosition + 6, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.toma.name || ''), 110), xPosition + 50, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', xPosition + 170, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.city || '') + (item.toma.state ? ' - ' + item.toma.state : ''), xPosition + 190, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', xPosition + 250, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.zipcode || ''), xPosition + 260, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', xPosition + 6, yPosition + 14);
          doc.setFont('helvetica', 'normal');
          doc.text(tomaAddress, xPosition + 28, yPosition + 14);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', xPosition + 230, yPosition + 14);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.country || ''), xPosition + 240, yPosition + 14);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', xPosition + 6, yPosition + 19);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.cnpj || ''), xPosition + 28, yPosition + 19);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', xPosition + 120, yPosition + 19);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.ie || ''), xPosition + 140, yPosition + 19);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', xPosition + 230, yPosition + 19);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.telephone || ''), xPosition + 243, yPosition + 19);

          yPosition += 21;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 30);
          const threeWidth = pageWidth / 3;
          doc.rect(xPosition + 5, yPosition, threeWidth - 6, 16);
          doc.rect(xPosition + threeWidth - 1, yPosition, threeWidth - 6, 16);
          doc.rect(xPosition + threeWidth * 2 - 7, yPosition, threeWidth - 8, 16);
          doc.setFont('helvetica', 'bold');
          doc.text('PRODUTO PREDOMINANTE', xPosition + 6, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.product || ''), xPosition + 6, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('OUTRAS CARACTERÍSTICAS DA CARGA', xPosition + threeWidth, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text('', xPosition + threeWidth, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('VALOR TOTAL DA CARGA', xPosition + threeWidth * 2 - 5, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text('R$ ' + formatNumber(item.productAmount), xPosition + threeWidth * 2 - 5, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('QUANTIDADE: ', xPosition + 6, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text('1', xPosition + 31, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('PESO BRUTO (KG): ', xPosition + 45, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text((item.peso || ''), xPosition + 80, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('QUANTIDADE DE PACOTES: ', xPosition + 102, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text('01', xPosition + 152, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('PESO AFERIDO (KG): ', xPosition + 167, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text((item.pesoAferido || ''), xPosition + 205, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('CUBAGEM(M3): ', xPosition + 230, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text((item.volumes || ''), xPosition + 260, yPosition + 25);

          yPosition += 32;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 30);
          const COMPONENTES = 'COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO';
          const COMPONENTESWidth = doc.getTextWidth(COMPONENTES);
          doc.setFont('helvetica', 'bold');
          doc.text(COMPONENTES, (pageWidth - COMPONENTESWidth) / 2, yPosition + 5);
          doc.rect(xPosition + 5, yPosition + 8, pageWidth - 20, 0);
          yPosition += 8;
          // const fourWidth = pageWidth / 4;
          doc.setFont('helvetica', 'normal');
          const dataItem = item.prest.freteDetail || [];
          const fourWidth = (pageWidth - 70) / dataItem.length;
          dataItem.map((item, index) => {
            doc.text('NOME', (xPosition + (index === 0 ? 6 : 0)) + index * fourWidth, yPosition + 5);
            doc.text('VALOR', (fourWidth - 18) + index * fourWidth, yPosition + 5);
            doc.text(doc.splitTextToSize((item.name || ''), 20), (xPosition + (index === 0 ? 6 : 0)) + index * fourWidth, yPosition + 10);
            doc.text(formatNumber(item.value), (fourWidth - 18) + index * fourWidth, yPosition + 10);
            doc.rect(fourWidth * (index + 1), yPosition, 0, 22);
          });
          const itemWidth = dataItem.length > 0 ? fourWidth * dataItem.length + 2 : 238;
          doc.text('VALOR TOTAL DO SERVIÇO', itemWidth, yPosition + 5);
          doc.text('R$ ' + formatNumber(item.prest.frete), itemWidth, yPosition + 10);
          doc.text('VALOR TOTAL A RECEBER', itemWidth, yPosition + 15);
          doc.text('R$ ' + formatNumber(item.prest.receivablesFee), itemWidth, yPosition + 20);

          yPosition += 22;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 23);
          doc.setFont('helvetica', 'bold');
          const IMPOSTO = 'INFORMAÇÕES RELATIVAS A IMPOSTO';
          const IMPOSTOWidth = doc.getTextWidth(IMPOSTO);
          doc.text(IMPOSTO, (pageWidth - IMPOSTOWidth) / 2, yPosition + 5);
          doc.rect(xPosition + 5, yPosition + 8, pageWidth - 20, 0);
          doc.setFont('helvetica', 'normal');
          doc.text('CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO', xPosition + 6, yPosition + 15);
          doc.text((item.icms.cst || ''), xPosition + 6, yPosition + 20);
          doc.rect(xPosition + 85, yPosition + 8, 0, 15);
          doc.text('BASE DE CÁLCULO', xPosition + 90, yPosition + 15);
          doc.text('R$ ' + formatNumber(item.icms.vbc), xPosition + 90, yPosition + 20);
          doc.rect(xPosition + 130, yPosition + 8, 0, 15);
          doc.text('ALÍQUOTA DO ICMS', xPosition + 135, yPosition + 15);
          doc.text((item.icms.picms || 0) + ' %', xPosition + 135, yPosition + 20);
          doc.rect(xPosition + 180, yPosition + 8, 0, 15);
          doc.text('VALOR DO ICMS', xPosition + 185, yPosition + 15);
          doc.text('R$ ' + formatNumber(item.icms.vicms), xPosition + 185, yPosition + 20);
          doc.rect(xPosition + 230, yPosition + 8, 0, 15);
          doc.text('% RED BC.', xPosition + 235, yPosition + 15);
          doc.text('% ' + (item.icms.predbc || 0), xPosition + 235, yPosition + 20);

          yPosition += 23;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 40);
          doc.setFont('helvetica', 'bold');
          const DOCUMENTOS = 'DOCUMENTOS ORIGINÁRIOS(NOTA FISCAL ELETRÔNICA)';
          const DOCUMENTOSWidth = doc.getTextWidth(DOCUMENTOS);
          doc.text(DOCUMENTOS, (pageWidth - DOCUMENTOSWidth) / 2, yPosition + 5);
          doc.rect(xPosition + 5, yPosition + 8, pageWidth - 20, 0);
          doc.setFont('helvetica', 'normal');
          doc.text('MODELO', xPosition + 6, yPosition + 12);
          doc.text((item.associationCte.modelo || ''), xPosition + 6, yPosition + 17);
          doc.text('SERIE', xPosition + 30, yPosition + 12);
          doc.text((item.associationCte.serie || ''), xPosition + 30, yPosition + 17);
          doc.text('NÚMERO', xPosition + 60, yPosition + 12);
          doc.text((item.associationCte.number || ''), xPosition + 60, yPosition + 17);
          doc.text('CHAVE DE ACESSO', xPosition + 90, yPosition + 12);
          doc.text(doc.splitTextToSize((item.associationCte.key || ''), 47), xPosition + 90, yPosition + 17);
          doc.rect(pageWidth / 2, yPosition + 8, 0, 32);

          doc.text('MODELO', pageWidth / 2 + 5, yPosition + 12);
          doc.text((item.nfeOriginalFile.modelo || ''), pageWidth / 2 + 5, yPosition + 17);
          doc.text('SERIE', pageWidth / 2 + 30, yPosition + 12);
          doc.text(doc.splitTextToSize((item.nfeOriginalFile.serie || ''), 29), pageWidth / 2 + 30, yPosition + 17);
          doc.text('NÚMERO', pageWidth / 2 + 60, yPosition + 12);
          doc.text(doc.splitTextToSize((item.nfeOriginalFile.number || ''), 29), pageWidth / 2 + 60, yPosition + 17);
          doc.text('CHAVE DE ACESSO', pageWidth / 2 + 90, yPosition + 12);
          doc.text(doc.splitTextToSize((item.nfeOriginalFile.key || ''), 47), pageWidth / 2 + 90, yPosition + 17);
          // doc.rect(xPosition + 5, yPosition + 30, pageWidth - 20, 0);
          // doc.text('INFORMAÇÕES ADICIONAIS', xPosition + 6, yPosition + 35);

          doc.addPage();
          yPosition = 3;
          doc.rect(xPosition, yPosition, pageWidth - 10, pageHeight - 6);
          doc.setFont('helvetica', 'bold');
          doc.text('INFORMAÇÕES ADICIONAIS', xPosition + 6, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          yPosition += 8;
          const itemAdditionalInfo = item.additionalInfo || [];
          itemAdditionalInfo.map(item => {
            yPosition += 5;
            if (yPosition > pageHeight - 10) {
              doc.addPage();
              yPosition = 13; // 新页面的起始位置，留出边框空间
              // 为新页面添加外围边框
              doc.rect(xPosition, 3, pageWidth - 10, pageHeight - 6);
            }
            doc.text(item, xPosition + 6, yPosition);
          });
          if (yPosition > pageHeight - 10) {
            doc.addPage();
          }
          doc.rect(xPosition + 5, yPosition + 3, pageWidth - 20, 25);
          doc.text('INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO', xPosition + 6, yPosition + 8);
          doc.rect(xPosition + 5, yPosition + 13, pageWidth - 20, 0);
          doc.text('RNTRC DA EMPRESA', xPosition + 6, yPosition + 20);
          doc.text((item.company.rntrc || ''), xPosition + 6, yPosition + 25);
          doc.rect(xPosition + 5, yPosition + 13, 80, 15);
          doc.text('ESTE CONHECIMENTO DE TRANSPORTE ATENDE À LEGISLAÇÃO DE TRANSPORTE RODOVIÁRIO EM VIGOR', xPosition + 90, yPosition + 20);
          yPosition += 30;
          if (yPosition > pageHeight - 10) {
            doc.addPage();
          }
          doc.rect(xPosition + 5, yPosition + 3, pageWidth - 20, 30);
          doc.rect(pageWidth / 2, yPosition + 3, 0, 30);
          doc.text('USO EXCLUSIVO DO EMISSOR DO CT - E', xPosition + 6, yPosition + 8);
          doc.text('RESERVADO AO FISCO', pageWidth / 2 + 5, yPosition + 8);
          doc.rect(xPosition + 5, yPosition + 10, pageWidth - 20, 0);
          // 返回PDF的Blob
          resolve(doc.output('blob'));
        } catch (error) {
          console.error('Error in generateSinglePDF:', error);
          resolve(new Blob()); // 返回空Blob以避免中断整个流程
        }
      });
    },
    // 更新容器高度
    updateContainerHeight() {
      if (this.$refs.virtualContainer) {
        this.containerHeight = this.$refs.virtualContainer.clientHeight || 600;
        this.visibleItemCount = Math.ceil(this.containerHeight / this.itemHeight) + 2; // 多渲染几个item以确保滚动顺畅
      }
    },

    // 处理滚动事件
    handleScroll(event) {
      const scrollTop = event.target.scrollTop;
      const newStartIndex = Math.floor(scrollTop / this.itemHeight);

      // 只有当起始索引发生变化时才更新
      if (newStartIndex !== this.visibleStartIndex) {
        this.visibleStartIndex = newStartIndex;
        this.offsetY = newStartIndex * this.itemHeight;
      }
    }
  }
};
</script>
<style>
.custom-loading-zIndex {
  z-index: 3000 !important;
}
</style>
<style scoped>
.virtual-scroll-container {
  height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
  margin: 10px 0;
}

.virtual-scroll-placeholder {
  position: relative;
}

.virtual-scroll-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
